module.exports = __webpack_public_path__ + "img/graph-paper-notebook_B099TQ5BZQ.2dcefb1e.jpg";